import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import './ModalForms.css';

const FilesFiltersModal = ({
  isOpen,
  onClose,
  initialDateFrom = '',
  initialDateTo = '',
  initialCreationDateFrom = '',
  initialCreationDateTo = '',
  initialStatuses = ['Completo', 'Incompleto'],
  onApply
}) => {
  const DEFAULT_STATUSES = ['Completo', 'Incompleto'];
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [creationDateFrom, setCreationDateFrom] = useState('');
  const [creationDateTo, setCreationDateTo] = useState('');
  const [statuses, setStatuses] = useState(DEFAULT_STATUSES);

  useEffect(() => {
    if (!isOpen) return;
    setDateFrom(initialDateFrom || '');
    setDateTo(initialDateTo || '');
    setCreationDateFrom(initialCreationDateFrom || '');
    setCreationDateTo(initialCreationDateTo || '');
    setStatuses(Array.isArray(initialStatuses) && initialStatuses.length ? initialStatuses : DEFAULT_STATUSES);
  }, [isOpen, initialDateFrom, initialDateTo, initialCreationDateFrom, initialCreationDateTo, initialStatuses]);

  const toggleStatus = (statusValue) => {
    setStatuses((prev) => {
      if (prev.includes(statusValue)) return prev.filter((item) => item !== statusValue);
      return [...prev, statusValue];
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onApply?.({
      dateFrom,
      dateTo,
      creationDateFrom,
      creationDateTo,
      statuses
    });
  };

  return (
    <Modal
      title="Filtrar"
      isOpen={isOpen}
      onClose={onClose}
      footer={(
        <div className="modal-footer">
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" form="files-filters-modal-form" className="btn">
              Aceptar
            </button>
          </div>
        </div>
      )}
    >
      <form id="files-filters-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Filtrar por fecha de creación (desde)
            <input
              type="date"
              value={creationDateFrom}
              onChange={(e) => setCreationDateFrom(e.target.value)}
            />
          </label>
          <label>
            Filtrar por fecha de creación (hasta)
            <input
              type="date"
              value={creationDateTo}
              onChange={(e) => setCreationDateTo(e.target.value)}
            />
          </label>
          <label>
            Filtrar por fecha de salida (desde)
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </label>
          <label>
            Filtrar por fecha de salida (hasta)
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </label>
          <div className="status-filter-group">
            <div className="filter-field-label">Filtrar por estado</div>
            <div className="status-filter-options">
              {['Completo', 'Incompleto', 'Deprecado'].map((statusOption) => (
                <label key={statusOption} className="status-filter-option">
                  <input
                    type="checkbox"
                    checked={statuses.includes(statusOption)}
                    onChange={() => toggleStatus(statusOption)}
                  />
                  {statusOption}
                </label>
              ))}
            </div>
          </div>
        </div>

      </form>
    </Modal>
  );
};

export default FilesFiltersModal;
